<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="ProjectTeam"
              @submit.prevent="onFileUpload"
            >
                <div class="content">
                    <h1>Confirmation Page</h1>
                    <br>
                    <div class="object-border">
                        <h2>Developer Information</h2>
                        <div class="columns">
                            <div class="column">
                                <p><b>Organization:</b> {{ FullSummaryApplication.Organization }}</p>
                                <p><b>Address:</b> {{ FullSummaryApplication.Address.Street1 }} {{ FullSummaryApplication.Address.Street2 }} {{ FullSummaryApplication.Address.City }}, {{ FullSummaryApplication.Address.State }} {{ FullSummaryApplication.Address.Zip }}</p>
                                <p><b>Entity Type:</b> {{ FullSummaryApplication.EntityType }}</p>
                                <p><b>Developer Description:</b> {{ FullSummaryApplication.DeveloperDescription }}</p>
                            </div>
                            <div class="column">
                                <p><b>Contact Name:</b> {{ FullSummaryApplication.Contact.Name }}</p>
                                <p><b>Email:</b> {{ FullSummaryApplication.Contact.Email }}</p>
                                <p><b>Phone:</b> {{ FullSummaryApplication.Contact.Phone }}</p>
                            </div>
                            <div class="column">
                                <p><b>Contact Name:</b> {{ FullSummaryApplication.SecondContact.Name }}</p>
                                <p><b>Email:</b> {{ FullSummaryApplication.SecondContact.Email }}</p>
                                <p><b>Phone:</b> {{ FullSummaryApplication.SecondContact.Phone }}</p>
                            </div>
                        </div>
                        <a href="/ProjectSummaryForm" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                    </div>
                    <br>
                    <div class="object-border">
                      <h2>Project Information</h2>
                      
                      <div class="columns">
                        <div class="column">
                          <p><b>Project Name:</b> {{ FullSummaryApplication.ProjectName }}</p>
                          <p><b>Proposal Type:</b> {{ FullSummaryApplication.ProposalType }}</p>
                          <p><b>Total Number of Units:</b> {{ FullSummaryApplication.NumberOfUnits }}</p>
                        </div>
                        <div class="column">
                          <p><b>DHCD/PHDC Funding Amount Requested:</b> {{ Number(FullSummaryApplication.FundingRequested).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                          <p><b>Total Development Cost:</b> {{ Number(FullSummaryApplication.TotalDevelopmentCost).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                          <p><b>Total Construction Cost:</b> {{ Number(FullSummaryApplication.TotalConstructionCost).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                        </div>
                        </div>
                        <div class="object-border">
                        <h3>Cost per Square Foot Calculations</h3>
                        <div class="columns">
                          <div class="column">
                            <p><b>Square Footage:</b> {{ FullSummaryApplication.SquareFootage }} ft²</p>
                            <p><b>Development Cost/SqFt:</b> {{ Number(FullSummaryApplication.DevelopmentCostPerSquareFoot).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                          </div>
                          <div class="column">
                            <p><b>Construct Cost/SqFt:</b> {{ Number(FullSummaryApplication.ConstructionCostPerSquareFoot).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                            <p><b>Subsidy Request Per Unit:</b> {{ Number(FullSummaryApplication.SubsidyPerUnit).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                          </div>
                        </div>
                        </div>
                        <br>
                        <div class="object-border">
                          <h3>Development Details</h3>
                          <div class="columns">
                            <div class="column">
                              <p><b>Development Category:</b> {{ FullSummaryApplication.DevelopmentCategory }}</p>
                              <p><b>Expiration Year:</b> {{ FullSummaryApplication.ExpirationYear }}</p>
                              <p><b>Population Served Description:</b> {{ FullSummaryApplication.PopulationServedDescription }}</p>
                              <p><b>Services Offered Description: </b> {{ FullSummaryApplication.ServicesOfferedDescription }}</p>
                              <p><b>Commercial Tenant:</b> {{ FullSummaryApplication.CommercialTenant }}</p>
                              <p v-if="FullSummaryApplication.Attributes.length > 0"><b>Project/Location Attributes:</b> {{ FullSummaryApplication.Attributes.join(", ") }}</p>
                              <p><b>Project Summary:</b> {{ FullSummaryApplication.ProjectDescription }}</p>
                            </div>
                            <div class="column">
                              <p v-if="FullSummaryApplication.DevelopmentCategory2 != null && FullSummaryApplication.DevelopmentCategory2 != ''"><b>Second Development Category:</b> {{ FullSummaryApplication.DevelopmentCategory2 }}</p>
                              <p><b>Population Served:</b> {{ FullSummaryApplication.PopulationServed.join(", ") }}</p>
                              <p><b>On-site Services Offered:</b> {{  FullSummaryApplication.ServicesOffered }}</p>
                              <p><b>Mixed-Use:</b> {{ FullSummaryApplication.MixedUse }}</p>
                              <p><b>Mixed Income Housing Bonus:</b> {{ FullSummaryApplication.MixedIncomeHousingBonus }}</p>
                              <p v-if="FullSummaryApplication.StrategyArea.length > 0"><b>Strategy Area:</b> {{ FullSummaryApplication.StrategyArea.join(", ") }}</p>
                              <p><b>Project Description:</b> {{ FullSummaryApplication.AdditionalFeatures }}</p>
                            </div>
                          </div>
                        </div>
                        <a href="/RFPProjectInformation" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                    </div>
                    <br>
                    <div class="object-border">
                      <h2>Project Team</h2>
                      <table style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%; font-size: 0.9em;">
                        <tr style="background-color: #2176d2; color: white;">
                          <td><b>Title</b></td>
                          <td><b>Company Name</b></td>
                          <td><b>State of Entity</b></td>
                          <td><b>Address</b></td>
                          <td><b>Name</b></td>
                          <td><b>Phone</b></td>
                          <td><b>Email</b></td>
                        </tr>
                        <tr>
                          <td style="border-right-width: 2px;">Borrower</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Borrower.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Borrower.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Borrower.Address.Street1 }} {{ FullSummaryApplication.Borrower.Address.Street2 }} {{ FullSummaryApplication.Borrower.Address.City }}, {{ FullSummaryApplication.Borrower.Address.State }} {{ FullSummaryApplication.Borrower.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Borrower.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Borrower.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.Borrower.Contact.Email }}</td>
                        </tr>
                        <tr v-if="FullSummaryApplication.GeneralPartnerOrManagingMember != 'Neither'">
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartnerOrManagingMember }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartner.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartner.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartner.Address.Street1 }} {{ FullSummaryApplication.GeneralPartner.Address.Street2 }} {{ FullSummaryApplication.GeneralPartner.Address.City }}, {{ FullSummaryApplication.GeneralPartner.Address.State }} {{ FullSummaryApplication.GeneralPartner.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartner.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.GeneralPartner.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.GeneralPartner.Contact.Email }}</td>
                        </tr>
                        <tr>
                          <td style="border-right-width: 2px;">Attorney</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Attorney.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Attorney.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Attorney.Address.Street1 }} {{ FullSummaryApplication.Attorney.Address.Street2 }} {{ FullSummaryApplication.Attorney.Address.City }}, {{ FullSummaryApplication.Attorney.Address.State }} {{ FullSummaryApplication.Attorney.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Attorney.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Attorney.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.Attorney.Contact.Email }}</td>
                        </tr>
                        <tr v-if="FullSummaryApplication.OptionalContacts.includes('Architect')">
                          <td style="border-right-width: 2px;">Architect</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Architect.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Architect.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Architect.Address.Street1 }} {{ FullSummaryApplication.Architect.Address.Street2 }} {{ FullSummaryApplication.Architect.Address.City }}, {{ FullSummaryApplication.Architect.Address.State }} {{ FullSummaryApplication.Architect.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Architect.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Architect.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.Architect.Contact.Email }}</td>
                        </tr>
                        <tr v-if="FullSummaryApplication.OptionalContacts.includes('Property Management Company')">
                          <td style="border-right-width: 2px;">Property Management Company</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.PropertyManagementCompany.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.PropertyManagementCompany.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.PropertyManagementCompany.Address.Street1 }} {{ FullSummaryApplication.PropertyManagementCompany.Address.Street2 }} {{ FullSummaryApplication.PropertyManagementCompany.Address.City }}, {{ FullSummaryApplication.PropertyManagementCompany.Address.State }} {{ FullSummaryApplication.PropertyManagementCompany.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.PropertyManagementCompany.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.PropertyManagementCompany.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.PropertyManagementCompany.Contact.Email }}</td>
                        </tr>
                        <tr v-if="FullSummaryApplication.OptionalContacts.includes('Consultant')">
                          <td style="border-right-width: 2px;">Consultant</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Consultant.CompanyName }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Consultant.StateOfEntity }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Consultant.Address.Street1 }} {{ FullSummaryApplication.Consultant.Address.Street2 }} {{ FullSummaryApplication.Consultant.Address.City }}, {{ FullSummaryApplication.Consultant.Address.State }} {{ FullSummaryApplication.Consultant.Address.Zip }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Consultant.Contact.Name }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.Consultant.Contact.Phone }}</td>
                          <td>{{ FullSummaryApplication.Consultant.Contact.Email }}</td>
                        </tr>
                      </table>
                      <a href="/ProjectTeam" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                    </div>
                    <br>
                    <div class="object-border">
                      <h2>Site Information</h2>
                      <table style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%; font-size: 0.9em;">
                            <tr style="background-color: #2176d2; color: white;">
                                <td><b>Address</b></td>
                                <td><b>Lot/Structure</b></td>
                                <td><b>Acquisition Method</b></td>
                                <td><b>Link to Site</b></td>
                            </tr>
                            <tr
                            v-for="site in FullSummaryApplication.Sites"
                            :key="site.id"
                            :class="`site-${site.id}`"
                            >
                                <td style="border-right-width: 2px;">{{ site.Street1 }} {{ site.Street2 }} {{  site.City }}, {{ site.State }} {{ site.Zip }}</td>
                                <td style="border-right-width: 2px;">{{ site.LotStructure }}</td>
                                <td style="border-right-width: 2px;">{{ site.AcqMethod }}</td>
                                <td><a :href="`/SiteInformation/${site.id}`">Edit Site {{ site.id }}</a></td>
                            </tr>
                    </table>
                    </div>
                    <br>
                    <div class="object-border">
                      <h2>Unit Details</h2>
                      <h3>Units by Size</h3>
                      <table style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%;">
                        <tr style="background-color: #2176d2; color: white;">
                            <td><b>Efficiency Units</b></td>
                            <td><b>One-Bedroom</b></td>
                            <td><b>Two-Bedroom</b></td>
                            <td><b>Three-Bedroom</b></td>
                            <td><b>Four-Bedroom or more</b></td>
                            <td><b>Total</b></td>
                        </tr>
                        <tr>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.NumberOfEfficiencyUnits }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.NumberOfOneBedroomUnits }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.NumberOfTwoBedroomUnits }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.NumberOfThreeBedroomUnits }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.NumberOfFourBedroomUnits}}</td>
                          <td>{{ FullSummaryApplication.TotalUnits }}</td>
                        </tr>
                      </table>
                      <h3>Units by AMI</h3>
                      <table style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%;">
                        <tr style="background-color: #2176d2; color: white;">
                            <td><b>0-20%</b></td>
                            <td><b>21-30%</b></td>
                            <td><b>31-50%</b></td>
                            <td><b>51-60%</b></td>
                            <td><b>61-80%</b></td>
                            <td><b>81-120%</b></td>
                            <td><b>>120%</b></td>
                            <td><b>Total</b></td>
                        </tr>
                        <tr>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI0to20 }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI20to30 }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI30to50 }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI50to60 }}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI60to80}}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI80to120}}</td>
                          <td style="border-right-width: 2px;">{{ FullSummaryApplication.AMI120Plus}}</td>
                          <td>{{ FullSummaryApplication.AMITotal }}</td>
                        </tr>
                      </table>
                      <h3>Unit Set-Asides</h3>
                      <div class="columns" style="margin-left: 1%;">
                        <div class="column">
                          <p><b>Mobility:</b> {{ FullSummaryApplication.Mobility }}</p>
                        </div>
                        <div class="column">
                          <p><b>Sensory:</b> {{ FullSummaryApplication.Sensory }}</p>
                        </div>
                        <div class="column">
                          <p><b>Visitable:</b> {{ FullSummaryApplication.Visitable }}</p>
                        </div>
                        <div class="column">
                          <p><b>Clearinghouse:</b> {{ FullSummaryApplication.Clearinghouse }}</p>
                        </div>
                      </div>
                      <a href="/UnitDetails" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                    </div>
                    <br>
                    <div class="object-border">
                      <h3>Development Questions</h3>
                      <br>
                      <div class="columns">
                        <div class="column">
                          <p><b>Do you have site control?:</b> {{ FullSummaryApplication.SiteControl }}</p>
                          <p><b>Has zoning been secured?:</b> {{ FullSummaryApplication.ZoningSecured }}</p>
                        </div>
                        <div class="column">
                          <p><b>Has a community meeting been held?:</b> {{ FullSummaryApplication.CommunityMeeting }}</p>
                          <p><b>What is the estimated construction timeline (in months)?:</b> {{ FullSummaryApplication.EstimatedConstructionTimeline }}</p>
                        </div>
                      </div>
                      <h4>Documents</h4>
                      <div class="columns">
                        <div class="column">
                          <p><b>Project Excel Workbook:</b> {{ FullSummaryApplication.ProjectWorkbook[0].name }}</p>
                          <!-- <p><b>EOP Form:</b> {{ FullSummaryApplication.EOPForm[0].name }}</p> -->
                        </div>
                        <div class="column">
                          <p><b>Proposal Narrative and Supporting Documents:</b> {{ FullSummaryApplication.ProposalDocuments[0].name }}</p>
                        </div>
                      </div>
                      <a href="/Development" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                    </div>
                    <br>
                    <callout type="warning" v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                      <b>Application is being submitted. This may take a few minutes. Please do not refresh or navigate away from this page.</b>
                    </callout>
                    <div class="column">
                      <div class="column">
                        <div class="column" style="text-align: right;">
                          <button
                            type="button"
                            class="button is-primary"
                            :disabled="SubmitStatus.Value === SubmitStatus.Options.PENDING"
                            @click="submit"
                            >
                            Submit
                          </button>
                          <div class="column">
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                      Submitting...
                    </div>
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                      OK
                    </div>
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                      Error
                    </div>
                  </div>
                  </div>
                      </div>
                    </div>
                </div>
                </input-form>
            </ValidationObserver>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
import buildCreateProjectSummaryObject from "@/utilities/create-sharc-project.js";
import buildProjectTeamObject from "@/utilities/create-team-member";
import buildSiteObject from "@/utilities/create-site-object.js";
import axios from "axios";
import options from "@/utilities/options";
import { dataObjectToXml } from "@/utilities/functions.js";

export default {
  name: 'RFPConfirmationPage',
  mixins: [options],
  data() {
    return {
      FullSummaryApplication: null,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    // phoneFormat(input) {
    //   if(!input || isNaN(input)) return `input must be a number was sent ${input}`
    //   if(typeof(input) !== 'string') input = input.toString()
    //   if(input.length === 10){
    //     return input.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    //   } else if(input.length < 10) {
    //     return 'was not supplied enough numbers please pass a 10 digit number'
    //   } else if(input.length > 10) {
    //     return 'was supplied too many numbers please pass a 10 digit number'
    //   }else{
    //     return 'something went wrong'
    //   }
    // },
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "RFPConfirmationPage",
            });
        }
    },
    async prevPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "Development",
            });
        }
    },
    async submitSite(recordId){
      var sites = this.FullSummaryApplication.Sites;
      for(var i = 0; i < sites.length; i++){
        var vData = sites[i];
        const dataObject = buildSiteObject(vData,recordId);

            const xmlDataObject = dataObjectToXml(dataObject);
            const requestObject = {
              table: "bn79uurex",
              action: "API_AddRecord",
              data: xmlDataObject
            };
        await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(() => {
                
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch((error) => {
                console.log(error);
                this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
                throw error;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              });
      }
    },
    async submitProject(ProjectWorkbookURL, ProposalDocumentsURL){
      var vData = this.FullSummaryApplication;

      var councilDistricts = [];

      var streetAddresses = [];
        
        console.log(this.FullSummaryApplication.Sites);
        for(var k = 0; k < this.FullSummaryApplication.Sites.length; k++){
          
          councilDistricts.push(this.FullSummaryApplication.Sites[k].CouncilDistrict);
          streetAddresses.push(this.FullSummaryApplication.Sites[k].Street1);

        }

            const dataObject = buildCreateProjectSummaryObject(vData, ProjectWorkbookURL, ProposalDocumentsURL, councilDistricts, streetAddresses);
 
            const xmlDataObject = dataObjectToXml(dataObject);
            const requestObject = {
              table: "bn79skuc6",
              action: "API_AddRecord",
              data: xmlDataObject
            };
        await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(async response => {
                await this.submitProjectTeam(response.data.qdbapi.rid._text);
                await this.submitSite(response.data.qdbapi.rid._text);
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch((error) => {
                console.log(error);
                this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
                throw error;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              });
    },
    async submitProjectTeam(recordID){
        var developer = {Role: "Developer Contact", CompanyName: this.FullSummaryApplication.Organization, StateOfEntity: this.FullSummaryApplication.Address.State, Address: { Street1: this.FullSummaryApplication.Address.Street1, Street2: this.FullSummaryApplication.Address.Street2, City: this.FullSummaryApplication.Address.City, State: this.FullSummaryApplication.Address.State, Zip: this.FullSummaryApplication.Address.Zip, Country: "United States" }, Contact: { Name: this.FullSummaryApplication.Contact.Name, Email: this.FullSummaryApplication.Contact.Email, Phone: this.FullSummaryApplication.Contact.Phone }};
        var developer2 = {Role: "Developer Contact", CompanyName: this.FullSummaryApplication.Organization, StateOfEntity: this.FullSummaryApplication.Address.State, Address: { Street1: this.FullSummaryApplication.Address.Street1, Street2: this.FullSummaryApplication.Address.Street2, City: this.FullSummaryApplication.Address.City, State: this.FullSummaryApplication.Address.State, Zip: this.FullSummaryApplication.Address.Zip, Country: "United States" }, Contact: { Name: this.FullSummaryApplication.SecondContact.Name, Email: this.FullSummaryApplication.SecondContact.Email, Phone: this.FullSummaryApplication.SecondContact.Phone }};

        this.FullSummaryApplication.GeneralPartner.Role = this.FullSummaryApplication.GeneralPartnerOrManagingMember;

        var projectTeam = [developer, developer2, this.FullSummaryApplication.Borrower, this.FullSummaryApplication.GeneralPartner, this.FullSummaryApplication.Architect, this.FullSummaryApplication.Attorney, this.FullSummaryApplication.PropertyManagementCompany, this.FullSummaryApplication.Consultant];

        for(var i = 0; i < projectTeam.length; i++){
          if(projectTeam[i].Contact.Name != null && projectTeam[i].Contact.Name != ''){


            var vData = projectTeam[i];
            const dataObject = buildProjectTeamObject(vData, recordID);

            const xmlDataObject = dataObjectToXml(dataObject);
            const requestObject = {
              table: "bpe7nrrxd",
              action: "API_AddRecord",
              data: xmlDataObject
            };
            await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(() => {
                
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch((error) => {
                console.log(error);
                this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
                throw error;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              });
          }
        }
    },
    uploadDocuments(){

    },
    async uploadToS3(presignedUrl, file) {
      
  
      const response = await axios(presignedUrl, {
        method: 'PUT',
        data: file
      });

      return response;
      
    },
    async onFileUpload(document) {
      for(var i = 0; i < document.length; i++){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        

        const file = document[i].file
        const fileName = `${this.FullSummaryApplication.ProjectName}/${document[i].name}`;


        let formData = { 'key': fileName };

        try {

          if(file.size/1000000 > 100){
      
             throw "File size is over 100MB"
           }
           var presignedURL;

          await axios.post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/dpd-SHARC-S3-Uploads", formData
          ).then(response => {

            presignedURL = response.data;
  
        }).catch(err => {
          

            this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
            document[i].uploading = false;
            document[i].error = true;
            console.log(err);
            document[i].errorMessage = err;
            console.log(err.response);
            throw err;

          });

          var newResponse = await this.uploadToS3(presignedURL, file);

          
          console.log(newResponse);
          if(newResponse.status != 200){
          throw "File Failed to Upload. Please try again."
        } 

        var URL = encodeURI(`https://d36c7re22txn7e.cloudfront.net/${this.FullSummaryApplication.ProjectName}/${document[i].name}`);

          var fileURL = `<a target = '_blank' href='${URL}'>${document[i].name}</a>`;
    
          return fileURL;
      }
      catch (err) {
          this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
          document[i].uploading = false;
          document[i].error = true;
          console.log(err);
          document[i].errorMessage = err;
          throw err
        }
    }
  },
    async submit(){
      this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
      var ProjectWorkbookURL = await this.onFileUpload(this.FullSummaryApplication.ProjectWorkbook);
      var ProposalDocumentsURL = await this.onFileUpload(this.FullSummaryApplication.ProposalDocuments);
      //var EOPFormURL = await this.onFileUpload(this.FullSummaryApplication.EOPForm);
      
    try{
       await this.submitProject(ProjectWorkbookURL, ProposalDocumentsURL);

       //console.log(result.response.status);

      //  if(result.response.status == 400){
      //    throw "An error occurred. Please try again."
      //  }

          
    } catch(e){
      this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
      //console.log(e);
      throw e;
    }
      this.SubmitStatus.Value = this.SubmitStatus.Options.SUCCESS;

      // delete cache upon successful submission
      this.$vlf.removeItem('fullSummaryApplication');
      
      this.$router.push({
          name: "RFPSuccessPage",
      });
  }
}
};
</script>

<style>
.object-border{
    border-width: 5px;
    border-style: solid;
    padding: 1%;
    border-radius: 10px;
    border-color: #0f4d90;
}
</style>